import { Box, Icon, Tab, Tabs } from "@nulogy/components";
import fromPairs from "lodash/fromPairs";
import React from "react";
import PublishErrorTabContent from "./PublishErrorTabContent";
import PublishSuccessTabContent from "./PublishSuccessTabContent";

function TabHeader({ color, icon, label }) {
  return (
    <>
      <Icon color={color} icon={icon} style={{ verticalAlign: "middle" }} title={label} />
      <Box display="inline-block" marginLeft="x1" verticalAlign="middle">
        {label}
      </Box>
    </>
  );
}

export default function PublishSummaryModalView({ summaryData }) {
  const { createdIds, updatedIds, workBlocks } = summaryData;
  if (!workBlocks) return null;

  const errors = fromPairs(summaryData.errors.map((error) => [error.path[2], error.message]));

  const workBlockResults = workBlocks.map((block, index) => ({
    error: errors[index],
    id: block.id,
    job: block.jobId,
    line: block.line.name,
    startTime: block.startsAt,
    workOrder: block.workOrder.code,
  }));

  const createErrorRows = workBlockResults.filter((block) => block.error && !block.job);
  const updateErrorRows = workBlockResults.filter((block) => block.error && block.job);
  const createSuccessRows = workBlockResults.filter((block) => !block.error && createdIds.includes(block.id));
  const updateSuccessRows = workBlockResults.filter((block) => !block.error && updatedIds.includes(block.id));

  const createTotal = createErrorRows.length + createSuccessRows.length;
  const updateTotal = updateErrorRows.length + updateSuccessRows.length;
  const errorTotal = createErrorRows.length + updateErrorRows.length;

  const defaultSelectedTabIndex = errorTotal > 0 ? 0 : 1;

  return (
    <Box mb="x1">
      <Tabs defaultSelectedIndex={defaultSelectedTabIndex} fitted>
        <Tab label={<TabHeader color="red" icon="error" label="Errors" />}>
          <PublishErrorTabContent
            createErrorRows={createErrorRows}
            createTotal={createTotal}
            updateErrorRows={updateErrorRows}
            updateTotal={updateTotal}
          />
        </Tab>
        <Tab label={<TabHeader color="green" icon="checkCircleOutline" label="Success" />}>
          <PublishSuccessTabContent
            createSuccessRows={createSuccessRows}
            createTotal={createTotal}
            updateSuccessRows={updateSuccessRows}
            updateTotal={updateTotal}
          />
        </Tab>
      </Tabs>
    </Box>
  );
}
